import React, { useEffect, useState } from 'react';
import Button from '../ui/Button';
import ThemeToggle from '../ui/ThemeToggle';

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const NAV = [
  { id: 'narrative', label: 'Approach' },
  { id: 'capabilities', label: 'Capabilities' },
  { id: 'process', label: 'Process' },
  { id: 'contact', label: 'Contact' },
];

export default function Header() {
  const [showStickyCta, setShowStickyCta] = useState(false);

  // The mobile CTA appears once the hero has scrolled away and hides again
  // over the contact form, where it would only cover the real button.
  useEffect(() => {
    const hero = document.querySelector('.hero');
    const contact = document.getElementById('contact');
    if (!hero) return undefined;

    let heroVisible = true;
    let contactVisible = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          if (entry.target === contact) contactVisible = entry.isIntersecting;
        });
        setShowStickyCta(!heroVisible && !contactVisible);
      },
      { threshold: 0.1 }
    );

    observer.observe(hero);
    if (contact) observer.observe(contact);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <button
            type="button"
            className="brand"
            onClick={() => scrollTo('top')}
            aria-label="Briva — back to top"
          >
            <img src="/logo.svg" alt="Briva" className="brand-logo" />
          </button>

          <nav className="topbar-nav" aria-label="Sections">
            {NAV.map((item) => (
              <button key={item.id} type="button" onClick={() => scrollTo(item.id)}>
                {item.label}
              </button>
            ))}
          </nav>

          <div className="topbar-actions">
            <ThemeToggle />
            <Button
              variant="primary"
              className="desktop-cta"
              onClick={() => scrollTo('contact')}
            >
              Start a conversation
            </Button>
          </div>
        </div>
      </header>

      <div className={`mobile-sticky-cta${showStickyCta ? ' visible' : ''}`}>
        <button type="button" className="mobile-cta-btn" onClick={() => scrollTo('contact')}>
          Start a conversation
        </button>
      </div>
    </>
  );
}
